/** BE OTP_RESEND_COOLDOWN_SECONDS (60) + 5s padding for clock/network skew */
export const OTP_RESEND_CLIENT_COOLDOWN_SECONDS = 65;
export const OTP_RESEND_CLIENT_COOLDOWN_MS =
  OTP_RESEND_CLIENT_COOLDOWN_SECONDS * 1000;

export const OTP_HASH_QUERY_PARAM = "hash";
export const OTP_FROM_REGISTER_QUERY_PARAM = "fromRegister";

export const OTP_FORM_FIELD = {
  CODE: "otpCode"
};

/** Map BE login/otp validation field names to FormBuilder field names */
export const OTP_BE_FIELD_TO_FORM_FIELD = {
  code: OTP_FORM_FIELD.CODE,
  hash: OTP_HASH_QUERY_PARAM
};

export function getOtpResendCooldownSecondsRemaining(
  otpLastSentAt,
  now = Date.now()
) {
  if (!otpLastSentAt) {
    return 0;
  }

  const remainingMs = OTP_RESEND_CLIENT_COOLDOWN_MS - (now - otpLastSentAt);

  return Math.max(0, Math.ceil(remainingMs / 1000));
}
